export default __webpack_public_path__ + "static/media/Banners_amazon500_gmm_330x330.bad1387f.png";